import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

const EditExpenseSapMigrationButton = ({
  handleEdit,
  expenseSapMigration,
  index,
}) => (
  <Button
    color="warning"
    outline
    className="mr-3"
    onClick={() => handleEdit(expenseSapMigration, index)}
    title="Editar"
  >
    <i className="fa fa-pencil" />
  </Button>
);

EditExpenseSapMigrationButton.propTypes = {
  expenseSapMigration: PropTypes.shape({}).isRequired,
  handleEdit: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default EditExpenseSapMigrationButton;
